import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSearchStore = defineStore('search', () => {
  const selected = ref<string>()

  return {
    selected,
  }
})
